// messageConstants.js
const MessageConstants = {
  LOGIN: {
    SUCCESS: "Successfully logged in.",
    FAILED: "Login failed. Please try again.",
  },
  EMPLOYEE: {
    CREATED: "Employee created successfully.",
  },
  COMMON: {
    UNKNOWN_ERROR: "Something went wrong.",
    REQUIRED_FIELDS: "Please fill the required fields!",
  },
  DEDUCTIONS:{
        HEALTH_INSURANCE_ALREADY_EXISTS:"A health insurance deduction already exists. Please complete or remove it before adding a new one.",
  }
};

export default MessageConstants;
